import { useState } from "react";
import { stats, siteInfo } from "@/mocks/siteContent";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const k = keyword.trim();
    const target = document.getElementById("hot");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
    if (k) {
      window.history.replaceState(null, "", `/?search=${encodeURIComponent(k)}`);
    }
  };

  return (
    <section id="home" className="relative flex min-h-[560px] w-full flex-col items-center justify-center overflow-hidden md:min-h-[640px]">
      <img
        src="https://readdy.ai/api/search-image?query=vibrant%20stylized%20Korean%20manhwa%20illustration%20banner%2C%20diverse%20cute%20animated%20characters%20floating%20among%20sparkles%20hearts%20and%20magic%20particles%2C%20warm%20coral%20orange%20and%20cream%20color%20palette%2C%20flat%20modern%20webtoon%20art%20style%2C%20dynamic%20dreamy%20composition%2C%20high%20detail&width=1600&height=900&seq=hero-manhwa-2026&orientation=landscape"
        alt="高清韩国漫画全题材在线阅读背景插画"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-50" />

      <div className="relative z-10 mx-auto w-full max-w-4xl px-4 py-20 text-center md:py-28">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-white/15 px-4 py-1.5 text-xs font-semibold text-white backdrop-blur">
          <i className="ri-flashlight-fill text-secondary-400" aria-hidden="true" />
          每日更新 · 高清画质 · 全题材收录
        </span>

        <h1 className="mt-6 font-heading text-3xl leading-tight text-white md:text-5xl md:leading-tight">
          追更高清韩国漫画
          <span className="mx-2 inline-block bg-gradient-to-r from-secondary-400 via-secondary-300 to-primary-300 bg-clip-text text-transparent">恋爱·奇幻·校园·悬疑</span>
          一网打尽
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base">
          分类齐全，恋爱、奇幻、校园、悬疑等题材应有尽有，完结排行榜助你快速挑选，每日更新热门作品，无论你偏爱哪种类型，都能轻松找到心仪之作。
        </p>

        <form onSubmit={handleSearch} className="mx-auto mt-8 flex max-w-xl items-center gap-2 rounded-full bg-white p-1.5 shadow-none" role="search">
          <i className="ri-search-line pl-3 text-xl text-foreground-400" aria-hidden="true" />
          <input
            type="search"
            name="keyword"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索你喜欢的漫画，如：恋爱、校园、悬疑…"
            aria-label="搜索漫画"
            className="h-11 w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="inline-flex h-11 shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm font-semibold text-white transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
          {["恋爱", "奇幻", "校园", "悬疑", "完结", "排行榜"].map((tag) => (
            <a
              key={tag}
              href="#categories"
              className="rounded-full bg-white/10 px-3.5 py-1.5 text-xs font-medium text-white transition-colors hover:bg-white/25"
            >
              #{tag}
            </a>
          ))}
        </div>

        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-white/10 px-4 py-4 text-white backdrop-blur">
              <p className="font-heading text-xl md:text-2xl">{s.value}</p>
              <p className="mt-1 text-xs text-white/75">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <p className="relative z-10 mb-6 hidden text-xs text-white/60 md:block" aria-hidden="true">
        {siteInfo.slogan}
      </p>
    </section>
  );
}